/* eslint-disable max-len */
import React from 'react'
import { isPresent } from 'ts-extras'
import { Leaf, Truck } from '~/components/Icons'
import { useTranslations } from '~/components/Locale'
import type { ShopifyHeaderSettings } from '~/types'
import { getPrice, gidToId, isHome, PRODUCT_IDS, useFreeShippingThreshold } from '~/utils'

const isAuk = () => window.PRODUCT?.id == gidToId(PRODUCT_IDS.Auk)

export const AnnouncementBarHeight = 42

export function showStartkitHeader(settings: ShopifyHeaderSettings) {
	return settings.show_header && (settings.product_page_only ? isAuk() : true)
}

export function showAnnouncementBar(settings: ShopifyHeaderSettings) {
	return settings.show_announcement && (settings.home_page_only ? isHome() : true)
}

export const showHeader = (settings: ShopifyHeaderSettings) =>
	showAnnouncementBar(settings) || showStartkitHeader(settings)

interface Props {
	isFixed: boolean
	settings: ShopifyHeaderSettings
}

export const AnnouncementBar: React.FC<Props> = ({ settings }) => {
	const t = useTranslations('react')
	const freeShippingThreshold = useFreeShippingThreshold()
	if (!showHeader(settings)) return null

	return (
		<div
			className="text-14 w-full py-3 font-semibold"
			role="banner"
			style={{
				height: `${AnnouncementBarHeight}px`,
				...(showAnnouncementBar(settings)
					? { color: settings.announcement_color_text, backgroundColor: settings.announcement_color_bg }
					: { color: settings.header_color_text, backgroundColor: settings.header_color_bg })
			}}
		>
			<div className="3xl:px-0 xs:auto-cols-fr mx-auto grid h-full max-w-[92vw] auto-cols-auto grid-flow-col justify-between xl:max-w-[159vh] xl:px-16">
				{showAnnouncementBar(settings) ? (
					<a
						href={settings.announcement_link}
						role="banner"
						className="a block w-full bg-gray-200 px-[3vw] py-4 text-center text-xl font-semibold"
					>
						{settings.announcement_text}
					</a>
				) : showHeader(settings) && isPresent(freeShippingThreshold) ? (
					<>
						<span className="align-content space-x-2 text-left align-middle text-inherit">
							<Leaf height="1.2em" />
							<span>{settings.header_text_1 || t?.checkout.return_policy_heading}</span>
						</span>
						<span className="align-content hidden space-x-2 text-center align-middle md:inline">
							<span>{settings.header_text_2 || t?.presale.limited_offer}</span>
						</span>
						<span className="align-content space-x-2 text-right align-middle">
							<span>
								{(settings.header_text_3 || t?.checkout.free_shipping)?.replace(
									'{FREE_SHIPPING_THRESHOLD}',
									getPrice(freeShippingThreshold, true)
								)}
							</span>
							<Truck />
						</span>
					</>
				) : null}
			</div>
		</div>
	)
}
